import CommonTableWrapper from 'components/CommonTableWrapper/CommonTableWrapper'
import moment from 'moment';
import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import WithAlert from "hoc/WithAlert";
import { uepClient } from 'uepClient';
import { tableIcons } from 'utils/MaterialTableHelper';
import colors from "styles/colors.module.scss";
import { FilterTextName, CallBackStatus, TableTitle } from 'constants/UserConstants'
import "../AgentRaiseQuery/AgentRaiseQuery.scss"
import { getUser, getUsername } from 'utils/Common';
import Select from "react-select";
import TableToolbar from 'components/AgentTableToolbar/TableToolbar';

const DATE_FORMAT = "DD MMM YYYY hh:mm a";
const endDate = moment().endOf('day').utc().format().toString();
const startDate = moment().startOf('day').utc().format().toString();


const assignStatus = [{
    label: CallBackStatus.NOT_STARTED,
    status: CallBackStatus.NOT_STARTED
}, {
    label: CallBackStatus.WORK_IN_PROGRESS,
    status: CallBackStatus.WORK_IN_PROGRESS
}
    , {
    label: CallBackStatus.NOT_REACHABLE,
    status: CallBackStatus.NOT_REACHABLE
}
    , {
    label: CallBackStatus.NOT_PICKED_UP,
    status: CallBackStatus.NOT_PICKED_UP
}
    , {
    label: CallBackStatus.CALL_CLOSED,
    status: CallBackStatus.CALL_CLOSED
}
]

export class AgentRequestCallBack extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            CallBackRequest: [],
            selectedRows: [],
            searchText: "",
            showPopUp: false,
            detailQuery: {},
            isEditMode: false,
            startDate: startDate,
            endDate: endDate,
            userName: getUsername(),
            requestId: null,
            assignRequestStatus: null,
            selectedCallbackStatus: null,
            status: assignStatus[0],
            assignedTo: "",
            filteredAgentID: "",
        };
    }

    componentDidMount() {
        this.fetchAllCallBackRequest(startDate, endDate)
    }

    render() {
        const { isLoading, showPopUp } = this.state
        return (

            <div className="agent-content">
                <div className="agent-list-table-container">
                    <div className="table-wrapper">
                        {this.renderTableToolbar()}
                        <CommonTableWrapper
                            icons={tableIcons}
                            columns={this.getTableColumns()}
                            data={this.getCallBackRequestData()}
                            isLoading={isLoading}
                            emptyMessage="No callback request found."
                            isModalOpen={this.openModalPopup}
                        />
                    </div>
                </div>
                <Modal
                    className="detailed-info-modal"
                    centered
                    onHide={this.closeModalPopup}
                    show={showPopUp}
                >
                    {this.renderQuery()}
                </Modal>
            </div>


        )
    }

    fetchAllCallBackRequest = (startDate, endDate) => {
        const { status, filteredAgentID } = this.state
        this.setState({ isLoading: true });

        uepClient()
            .get(`/callback-request?startDateTime=${startDate}&endDateTime=${endDate}${status ? `&status=${status.status}` : ``}${filteredAgentID != "" ? `&assignedTo=${filteredAgentID}` : ``}`)
            .then((res) => {
                this.setState({
                    CallBackRequest: res.data,
                    isLoading: false,
                });
            })
            .catch((err) => {
                console.error(`Failed to fetch list of callback request : ${err}`);
                // Resetting to default state 
                this.setState({
                    CallBackRequest: [],
                    isLoading: false,
                });
                this.props.showAlert({
                    variant: "danger",
                    content: (
                        <span>
                            <b>Error!</b> Failed to fetch the list of callback request, please try again.
                        </span>
                    ),
                });
            });
    };



    renderTableToolbar = () => {
        const { startDate, endDate, searchText, status, filteredAgentID, CallBackRequest } = this.state
        return (
            <TableToolbar
                searchValue={searchText}
                onSearchTextChange={this.onSearchTextChange}
                onDateChage={this.onDateChage}
                startDate={startDate}
                endDate={endDate}
                onRefreshClick={this.onRefreshClick}
                isButton={false}
                filterButtonText={FilterTextName.FilterRequest}
                onRecentData={this.onRecentQuery}
                statusDropDownList={assignStatus}
                selectedStatus={status}
                title={TableTitle.CallbackRequest}
                onStatusChange={this.onFilterStatusChange}
                agentId={filteredAgentID}
                onAgentIdSearch={this.onAgentIdSearch}
                tableDataCount={CallBackRequest.length}
            />
        );
    };

    getTableColumns = () => {
        const tableColumns = [
            {
                title: "Customer ID",
                field: "customerId",
                filtering: false,
                sorting: true,
            },
            {
                title: "Phone Number",
                field: "mobileNumber",
                filtering: true,
            },
            {
                title: "Status",
                field: "callbackRequestStatus",
                filtering: false,
            },
            {
                title: "AssignedTo",
                field: "assignedTo",
                filtering: false,
                render: (rowData) => {
                    if (rowData.assignedTo != null) {
                        return <span>{rowData.assignedTo}</span>
                    } else {
                        return <Button className="view-opty-btn" onClick={(e) => this.onAssignToMe({ id: rowData.id, status: CallBackStatus.NOT_STARTED })}>Assign To Me</Button>
                    }
                },
            },
            {
                title: "Created Date",
                field: "createdAt",
                defaultSort: "desc",
                render: (rowData) => {
                    return moment(rowData.createdAt).format(DATE_FORMAT)
                },
            },
            {
                title: "Updated Date",
                field: "updatedAt",
                defaultSort: "desc",
                render: (rowData) => {
                    return moment(rowData.updatedAt).format(DATE_FORMAT)
                },
            },
            {
                title: "View Request",
                filtering: false,
                sorting: false,
                render: rowData => <Button
                    className="view-details-btn"
                    label="View"
                    onClick={(e) => this.openModalPopup(rowData)}
                >View</Button>
            },
        ];

        const tableColumnsWithStyle = tableColumns.map((tc) => ({
            ...tc,
            cellStyle: {
                border: 0,
                color: colors.darkGrey,
                fontWeight: "normal",
            },
            headerStyle: {
                border: 0,
                color: colors.darkGrey,
                fontWeight: "500",
                fontSize: "1em",
            },
        }));
        return tableColumnsWithStyle;
    };

    renderQuery = () => {
        const { detailQuery, requestId, assignRequestStatus, selectedCallbackStatus } = this.state
        return (
            <div className='main-modal-card'>
                <div className='flex-card'>
                    <div className='user-detail'>
                        <label>Customer Id : </label>
                        <span>{detailQuery.customerId ? detailQuery.customerId : "NA"}  </span>
                    </div>
                    <div className='user-detail'>
                        <label>Mobile Number: </label>
                        <span>{detailQuery.mobileNumber ? detailQuery.mobileNumber : "NA"}</span>
                    </div>
                </div>
                <div className='flex-card'>
                    <div className='user-detail'>
                        <label>AssignedTo : </label>
                        {detailQuery.assignedTo ?
                            <span>{detailQuery.assignedTo}</span>
                            : requestId == detailQuery.id ?
                                <Button
                                    className="view-details-btn selected"
                                    label="Close"
                                    onClick={e => this.setState({
                                        requestId: null
                                    })}
                                >Assigned To You</Button> :
                                <Button
                                    className="view-details-btn"
                                    label="Close"
                                    onClick={e => this.setState({
                                        requestId: detailQuery.id
                                    })}
                                >Assign To Me</Button>}
                    </div>
                    <div className='user-detail'>
                        <label>Status : </label>
                        <Select
                            onChange={this.onStatusChange}
                            value={assignRequestStatus ? assignRequestStatus : selectedCallbackStatus}
                            options={assignStatus}
                            placeholder="Select Status"
                            styles={this.getDropdownStyles()}
                        />
                    </div>
                </div>
                <div className='flex-card'>
                    <div className='user-detail'>
                        <label>Requested CallBack Time : </label>
                        <span>{detailQuery.startDateTime ? `${moment(detailQuery.startDateTime).format("MMM DD, YYYY | h:mm A")} - ${moment(detailQuery.endDateTime).format("h:mm A")}` : "NA"}</span>
                    </div>

                </div>

                <div className='modal-footer'>
                    <Button
                        disabled={requestId == null && detailQuery.assignedTo == null ? true : ''}
                        className="form-agent-btn save-btn "
                        label="Close"
                        onClick={this.onModalSave}
                    >
                        save
                    </Button>
                    <Button
                        className="form-agent-btn cancel-btn "
                        label="Close"
                        onClick={this.closeModalPopup}
                    >
                        Close
                    </Button>
                </div>
            </div>
        )
    }

    onStatusChange = (selectedChannels) => {
        this.setState({
            assignRequestStatus: selectedChannels,
        })
    };

    onModalSave = () => {
        const { assignRequestStatus, requestId, detailQuery, status } = this.state;
        this.onAssignToMe({ id: requestId ? requestId : detailQuery.id, status: assignRequestStatus ? assignRequestStatus.status : status.status })
    }

    onAssignToMe = (item) => {
        const { startDate, endDate } = this.state
        const { id, status } = item

        const Body = {
            callbackRequestStatus: status,
            assignedTo: this.state.userName,
            updatedBy: this.state.userName
        }

        uepClient()
            .put(`/callback-request/${id}`, Body)
            .then((res) => {
                this.setState({
                    isLoading: false,

                });
                this.closeModalPopup()
                this.fetchAllCallBackRequest(startDate, endDate)

            })
            .catch((err) => {
                console.error(`Failed to assign callback request : ${err}`);
                // Resetting to default state 
                this.setState({
                    isLoading: false,
                });
                this.closeModalPopup()
                this.props.showAlert({
                    variant: "danger",
                    content: (
                        <span>
                            <b>Error!</b> Failed to assign callback request, please try again.
                        </span>
                    ),
                });
            });
    }

    onSearchTextChange = (searchText) => {
        this.setState({
            searchText,
        });
    };

    onAgentIdSearch = (searchText) => {
        this.setState({
            filteredAgentID: searchText,
        });
    };

    getCallBackRequestData = () => {
        const { CallBackRequest, searchText } = this.state;
        return searchText.trim().length
            ? CallBackRequest.filter((row) => this.validateSearch(row))
            : CallBackRequest;
    };

    validateSearch = (row) => {
        const { searchText } = this.state;
        const searchLc = searchText.toLowerCase();
        const customerIdValidator = row.customerId.toLowerCase().includes(searchLc);
        const phoneNumberValidator = row.mobileNumber.toLowerCase().includes(searchLc);
        const assignedUserValidator = row.assignedTo?.toLowerCase().includes(searchLc);
        const createdDateValidator =
            moment(row.createdAt)
                .format(DATE_FORMAT)
                .toString()
                .toLowerCase()
                .includes(searchLc)
        const updatedDateValidator =
            moment(row.updatedAt)
                .format(DATE_FORMAT)
                .toString()
                .toLowerCase()
                .includes(searchLc)

        return (customerIdValidator || phoneNumberValidator || createdDateValidator || updatedDateValidator || assignedUserValidator)
    };

    getDropdownStyles = () => {
        const customStyles = {
            container: (provided) => ({
                ...provided,
                width: "100%",
            }),
            control: (provided, { isDisabled }) => ({
                ...provided,
                width: "100%",
                minWidth: 120,
                height: 34,
                minHeight: 34,
                font: "normal normal bold 14px/19px Roboto",
                background: "white",
                paddingLeft: "0px",
                opacity: isDisabled ? 0.5 : 1,
                boxShadow: "0px 3px 6px #00000029",
                border: 0,
            }),
            option: (provided) => ({
                ...provided,
                background: "#fff",
                color: "#000",
                width: "100%",
                minWidth: 120,
                font: "Roboto",
                border: "none",
            }),
            dropdownIndicator: (provided, state) => ({
                ...provided,
                width: 28,
                paddingTop: 0,
                paddingBottom: 0,
                color: "#3c3c3f",
                transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
            }),
            multiValue: (provided) => ({
                ...provided,
                fontFamily: "Roboto",
                color: "#96969B",
            }),
            multiValueRemove: (provided) => ({
                ...provided,
                color: "#96969B",
                "&:hover": {
                    backgroundColor: "#3A8AFA",
                    color: "#fff",
                },
            }),
            menu: (provided) => ({
                ...provided,
            }),
            placeholder: (provided) => ({
                ...provided,
                fontWeight: "normal",
            }),
        };
        return customStyles;
    };

    openModalPopup = (item) => {

        assignStatus.map((statusItem) => {
            if (statusItem.status === item.callbackRequestStatus) {
                this.setState({
                    selectedCallbackStatus: statusItem
                })
            }
        })

        this.setState({
            showPopUp: true,
            detailQuery: item,
        })
    }
    // Close Popup modal
    closeModalPopup = () => {
        this.setState({
            showPopUp: false,
            detailQuery: {},
            assignRequestStatus: null,
            requestId: null
        })
    }

    onDateChage = (date) => {
        const changeStartDate = date.startDate ? moment(date.startDate).utc().format().toString() : this.state.startDate;
        const changeEndDate = date.endDate ? moment(date.endDate).utc().format().toString() : this.state.endDate;
        this.setState({
            startDate: changeStartDate,
            endDate: changeEndDate
        });
    }

    onFilterStatusChange = (status) => {
        this.setState({
            status: status
        });
    }

    onRecentQuery = () => {
        const { startDate, endDate } = this.state

        this.fetchAllCallBackRequest(startDate, endDate)
    }

    onRefreshClick = () => {
        this.setState({
            startDate: startDate,
            endDate: endDate,
            status: assignStatus[0],
            filteredAgentID: "",
        })
        this.fetchAllCallBackRequest(startDate, endDate)
    }
}

export default WithAlert(AgentRequestCallBack)